<template>
  <div class="warpper">
    <HeadNei :active="'Policy'" />
    <div class="content flex">
      <div class="con-nav">
        <div
          :class="
            active == index ? 'nav_item active whole-bgt' : 'nav_item whole-bgt'
          "
          v-for="(item, index) in menuListData"
          :key="index"
          @click="handleMenuClick(index, item)"
          v-on:click="toPolicy"
        >
          <div class="nav-item-cont">
            <div class="nac_icon"></div>
            <p>{{ item.category }}</p>
          </div>
        </div>
      </div>
      <div class="con_box">
        <div class="con_tt whole-bgt">
          <span v-on:click="toPolicy" :class="isContent ? 'back' : ''">{{
            activeName || "--"
          }}</span>
          <span v-show="isContent">>政策详情</span>
        </div>
        <div class="con_bd" v-if="!isContent">
          <div class="con_flex">
            <div
              :class="
                artiveChang
                  ? 'staActive con_content'
                  : item.title
                  ? 'endActive con_content'
                  : 'con_content'
              "
              class="articalList"
              v-for="(item, index) in artiveInfo"
              @click="catContent(item)"
              :key="index"
              id="articl"
            >
              <span>{{ item && item.title }}</span>
              <span>{{ item && item.createdAt }}</span>
            </div>
          </div>
          <div class="con_pag">
            <el-pagination
              background
              layout="prev, pager, next,total"
              hide-on-single-page
              :page-size="pageSize"
              :current-page="currentPage"
              :total="total"
              @current-change="handleCurrentChange"
            ></el-pagination>
          </div>
        </div>
        <div class="policyContentWrap" v-else>
          <span class="policyContentTitle">{{ policyContent.title }}</span>
          <div class="policyContent" v-html="policyContent.content"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeadNei from "@/components/HeadNei.vue";
export default {
  name: "Policy",
  components: {
    HeadNei,
  },
  data() {
    return {
      menuListData: [],
      artiveInfo: [],
      articleId: 0,
      activeName: "",
      artiveChang: false,
      active: 0,
      total: 0,
      pageSize: 10,
      currentPage: 1,
      isContent: false,
      policyContent: "",
    };
  },
  methods: {
    async initMenuList() {
      const { result } = await this.$api.details.getCategoryList("2");
      this.menuListData = result;
      this.activeName = result[0].category;
      this.articleId = result[0].id;
      this.initArticleDetail();
    },
    handleMenuClick(key, value) {
      this.artiveChang = true;
      this.active = key;
      this.activeName = value.category;
      this.articleId = value.id;
      this.currentPage = 1;
      this.initArticleDetail();
    },
    async initArticleDetail() {
      const { articleId } = this;
      const { currentPage } = this;
      const { result } = await this.$api.details.getArticleList({
        categoryId: articleId,
        current: currentPage,
        size: 10,
      });
      this.currentPage = result.current;
      this.pageSize = result.size;
      this.total = result.total;
      this.artiveInfo = result.records;
      this.artiveChang = false;
    },
    handleCurrentChange(val) {
      this.artiveChang = true;
      this.currentPage = val;
      this.initArticleDetail();
    },
    catContent(policy) {
      console.log(policy);
      this.policyContent = policy;
      this.isContent = true;
    },
    toPolicy() {
      this.isContent = false;
    },
  },
  mounted() {
    this.initMenuList();
  },
};
</script>
<style scoped>
.warpper {
  background: url(../assets/images/nei-bj.png), #091f36;
  min-height: 100vh;
}
/* .articalList {
  font-size: 40px;
  margin: 3px 0;
  padding-left: 20px;
  line-height: 40px;
  height: 40px;
} */
.content {
  padding: 0 36px 36px;
}
#articl:hover {
  cursor: pointer;
}
.con-nav {
  width: 256px;
  margin: 0 34px 0 0;
}

.nav_item {
  width: 100%;
  height: 92px;
  background-image: url(../assets/images/nei-nav.png);
  padding: 29px 0 0 24px;
}

.nav_item .nav-item-cont {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
}

.nav_item p {
  font-size: 24px;
  font-weight: bold;
  color: #ffffff;
  transform: skewX(-10deg);
}

.nav_item .nac_icon {
  width: 28px;
  height: 30px;
  margin-right: 16px;
  background-image: url(../assets/images/ic1.png);
  background-size: cover;
}

.nav_item_b .nac_icon {
  background-image: url(../assets/images/ic2.png);
}

.nav_item_c .nac_icon {
  background-image: url(../assets/images/ic3.png);
}

.nav_item_d .nac_icon {
  background-image: url(../assets/images/ic4.png);
}

.nav_item.active,
.nav_item:hover {
  background-image: url(../assets/images/nei-nav-on.png);
}

.nav_item.active p,
.nav_item:hover p {
  background-image: -webkit-linear-gradient(bottom, #b9e4ff, #ffffff);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.nav_item.active .nac_icon,
.nav_item:hover .nac_icon {
  background-image: url(../assets/images/ic1_on.png);
}

.nav_item_b.active .nac_icon,
.nav_item_b:hover .nac_icon {
  background-image: url(../assets/images/ic2_on.png);
}

.nav_item_c.active .nac_icon,
.nav_item_c:hover .nac_icon {
  background-image: url(../assets/images/ic3_on.png);
}

.nav_item_d.active .nac_icon,
.nav_item_d:hover .nac_icon {
  background-image: url(../assets/images/ic4_on.png);
}

.con_box {
  flex: 1;
  margin-top: 30px;
}

.con_tt {
  background-image: url(../assets/images/deta-tt.png);
  width: 398px;
  height: 52px;
  font-size: 20px;
  font-weight: bold;
  line-height: 46px;
  padding-left: 70px;
}

.con_tt span {
  background-image: -webkit-linear-gradient(bottom, #b9e4ff, #ffffff);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.con_bd {
  background-color: rgba(7, 58, 94, 0.7);
  border: 1px solid #00bbe9;
  position: relative;
  padding: 56px 56px 28px 56px;
  color: #ffffff;
  font-size: 18px;
}

.con_bd::before,
.con_bd::after {
  content: "";
  width: 10px;
  height: 10px;
  background-image: url(../assets/images/san.png);
  background-size: cover;
  position: absolute;
  bottom: 2px;
  right: 2px;
}

.con_bd::after {
  right: auto;
  left: 2px;
  transform: rotateY(180deg);
}

.con_time {
  font-size: 16px;
  text-align: center;
  margin-bottom: 34px;
}

.con_flex {
  height: 680px;
  overflow-y: auto;
  filter: contrast(15);
}
.con_content::before {
  position: absolute;
  content: "";
  top: 14px;
  left: 6px;
  width: 6px;
  height: 2px;
  background-color: #008fb3a6;
}
.policyContent {
  font-size: 20px;
  color: white;
  /* text-indent: 2em; */
}
.policyContent::first-letter {
  text-indent: 2em;
}
.policyContentTitle {
  font-size: 28px;
  color: #fff2ff;
  text-indent: 2em;
  text-align: center;
  display: block;
  margin: bottom 20px;
}
.back:hover {
  cursor: pointer;
}

.staActive {
  animation: staChange 0.5s normal ease;
}

@keyframes staChange {
  0% {
    filter: blur(0px);
    opacity: 1;
  }

  50% {
    filter: blur(40px);
    opacity: 0.5;
  }

  100% {
    filter: blur(80px);
    opacity: 0;
  }
}

.endActive {
  display: flex;
  justify-content: space-between;
  animation: endChange 0.5s normal ease;
}

@keyframes endChange {
  0% {
    filter: blur(80px);
    opacity: 0;
  }

  50% {
    filter: blur(40px);
    opacity: 0.5;
  }

  100% {
    filter: blur(0px);
    opacity: 1;
  }
}
.con_flex::-webkit-scrollbar-corner {
  background-color: #073a5e;
}

.con_flex::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  border-radius: 3px;
}

.con_flex::-webkit-scrollbar-track {
  background: none;
}

.con_flex::-webkit-scrollbar-thumb {
  background-color: #073a5e;
  border-radius: 3px;
}

.con_content {
  position: relative;
  line-height: 32px;
  text-indent: 36px;
}

.con_content span + span {
  margin-top: 24px;
}
.con_pag {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
